import { Store, AnyAction } from 'redux';

export const isForbiddenErrorAction = (action: AnyAction) => {
    if (typeof action.type !== 'string') {
        return false;
    }
    if (!(action.payload instanceof Error)) {
        return false;
    }
    const { message } = action.payload;
    return message === "FORBIDDEN";
};

export const reauthenticationMiddleware = (/* { dispatch }: Store<any> */) => (next: (a: AnyAction) => unknown) => (action: AnyAction) => {
    if (isForbiddenErrorAction(action)) {
        //dispatch(showLoginDialog());
        console.log('TODO... show login dialog'); // TODO
        // but also... fix the session saga to not redirect after successful login.
    }

    return next(action);
};
